import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom';
import { useModalBackButton } from '../hooks/useModalBackButton';

function TitleWithSelection({ title = '', children = null }) {
    const [isOpen, setIsOpen] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const [startPostition, setStartPosition] = useState(0)

    useEffect(() => {
        updatePosition();
        window.addEventListener("resize", updatePosition);
        return () => window.removeEventListener("resize", updatePosition);
    }, [isOpen])

    useEffect(() => {
        const handler = (e) => {
            const sidebar = document.querySelector('.hel-sidebar');

            if (!sidebar) return;

            // Only react to sidebar transitions
            if (sidebar.contains(e.target)) {
                updatePosition();
            }
        };

        document.addEventListener('transitionend', handler);
        return () => document.removeEventListener('transitionend', handler);
    }, []);


    const updatePosition = () => {
        const arrowIcon = document.querySelector(".img-arrow-down");
        if (arrowIcon) {
            const rect = arrowIcon.getBoundingClientRect();
            setPosition({ top: rect.bottom, left: rect.left });
        }

        const startPostition = document.querySelector(".title-selection");
        if (startPostition) {
            const newRect = startPostition.getBoundingClientRect();
            setStartPosition(newRect.left)
        }
    };

    const handleClick = (event) => {
        event.stopPropagation()
        setIsOpen(!isOpen);
    };

    const handleClose = () => {
        setIsOpen(false)
    }

    useModalBackButton(isOpen, handleClose)

    return (
        <div className='dropdown-container-header'>
            <div className='title-selection' onClick={handleClick}>
                <h5 className="title">{title}</h5>
                <div className='img-arrow-down'>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="Icon">
                            <path id="Icon Color" fillRule="evenodd" clipRule="evenodd" d="M11.0417 3.75L10.0417 2.75L5.54175 7.25L1.04175 2.75L0.041748 3.75L5.54175 9.25L11.0417 3.75Z" />
                        </g>
                    </svg>
                </div>
            </div>

            {isOpen && (
                createPortal(
                    <div className={"dropdown-menu default-page-popup"} style={{ "--arrow-left": position.left - 6 + "px", "--arrow-top": position.top + 11 + "px" }}
                        onClick={() => handleClose()} >
                        <div className="toggle-container toggle-animation" style={{ marginTop: position.top + 3, marginLeft: startPostition > 0 ? startPostition : position.left - 100 }}
                            onClick={(e) => e.stopPropagation()}>
                            {children}
                        </div>
                    </div>,
                    document.body
                )
            )}
        </div>
    )
}

export default TitleWithSelection